import HelpIcon from '@/components/HelpIcon.jsx';
import Tag from '@/components/Tag.jsx';
import IconV2 from '@/components/v2/IconV2';
import { InformationIcon } from '@/lib/constants/icons';
import ArgumentDescription from './ArgumentDescription.jsx';
import ArgumentExternalRecordView from './ArgumentExternalRecordView.jsx';

const ArgumentLabel = ({ argKey, className = '', dataTitle, info, description, variant, icon, leftIcon, iconProps, isRequired, label, title, valid = false, helpIconContext, children, tag, isId = false, custom = false, dataSource, lookupActionId, overrideAction }) => {
  const getFullTitle = () => {
    if (!title) {
      return;
    }
    return `${title}${isRequired ? ' (required)' : ''}`;
  };

  const fullTitle = getFullTitle();

  return (
    <div className={`comp-argument-label ${isRequired ? 'required' : ''} ${className}`.trim()}>
      <div className="label-row">
        <div className="left">
          {leftIcon && <IconV2 icon={leftIcon} title={fullTitle} className={`${isRequired ? 'error' : ''} ${valid ? 'valid' : ''} ${custom ? 'custom' : ''}`} {...iconProps} />}
          {label && <span data-title={dataTitle || label}>{label}</span>}
          {icon && <IconV2 icon={icon} title={fullTitle} className={`${isRequired ? 'error' : ''} ${valid ? 'valid' : ''} ${custom ? 'custom' : ''}`} {...iconProps} />}
          {tag && <Tag variant={'info'}>{tag}</Tag>}
          {info && <IconV2 icon={InformationIcon} title={info} className={'argument-info'} variant={'light'} />}
          {helpIconContext && <HelpIcon context={helpIconContext} />}
        </div>
        {(children || isId) && (
          <div className="right">
            {children}
            {isId && <ArgumentExternalRecordView argKey={argKey} dataSource={dataSource} lookupActionId={lookupActionId} overrideAction={overrideAction} />}
          </div>
        )}
      </div>
      <ArgumentDescription description={description} variant={variant} />
    </div>
  );
};

export default ArgumentLabel;
